/**
 * Form Validation for WooCommerce Login and Registration Forms
 *
 * Handles client-side validation for login and registration forms
 * with visual feedback and error messages.
 */

(function($) {
    'use strict';

    /**
     * Initialize form validation
     */
    function initFormValidation() {
        setupRegistrationFormValidation();
    }

    /**
     * Setup registration form validation
     */
    function setupRegistrationFormValidation() {
        const $registrationForm = $('.woocommerce-form-register');

        if ($registrationForm.length === 0) return;

        // Ensure email field has the correct type
        const $emailField = $registrationForm.find('input[name="email"]');
        if ($emailField.length > 0 && $emailField.attr('type') !== 'email') {
            $emailField.attr('type', 'email');
        }
    }

    // Initialize when DOM is ready
    $(document).ready(function() {
        initFormValidation();
    });

})(jQuery);
